const accessRoute = {
  NOTIFICATIONS: {
    path: "/admin/notifications",
  },
};
export default accessRoute;
